import { render, staticRenderFns } from "./page_sidebar.vue?vue&type=template&id=0776244a"
import script from "./page_sidebar.vue?vue&type=script&lang=js"
export * from "./page_sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports